<template>
  <div class="patientlendingprogramcontent">
    <h1 class="patient-lending-program-header">Patient Lending</h1>

    <h2 class="patient-lending-program-header2">
      Let us help you manage your healthcare payments
    </h2>

    <p class="patient-lending-program-main">
      Medical bills can add up quickly, putting financial strain on patients and families. Commerce Bank understands
      these challenges and is proud to offer 
      <b>Health Services Financing (HSF<span class="sup">&reg;</span>) </b>- a convenient patient lending option. Find your provider to
      get started.
    </p>

    <SecondaryButton class="find-provider-btn" :text="'Find Your Provider'"
      @clickHandler="PatientLendingProgramsClick" />
  </div>
</template>

<script>
import SecondaryButton from "@Shared/components/SecondaryButton.vue";
import router from "../../router";

export default {
  name: "PatientLendingPrograms",
  components: {
    SecondaryButton,
  },

  methods: {
    PatientLendingProgramsClick() {
      router.push({ name: "search" });
    },
  },
};
</script>

<style lang="scss" scoped>
.patientlendingprogramcontent {
  margin-left: 15%;

  @media all and (max-width: $grid-breakpoint-lg) {
    margin-left: 0;
  }

  .find-provider-btn {
    width: 250px;
    height: 65px;
    margin-top: 30px;

    @media all and (max-width: $grid-breakpoint-lg) {
      width: 100%;
      margin-bottom: 15px;
      padding: 15px;
      border-radius: 5px;
    }
  }
}

.sup {
  font-size: 70%;
  vertical-align: super;
}

.patient-lending-program-section {
  @media all and (max-width: $grid-breakpoint-lg) {
    margin-bottom: 115px;
  }

  .patient-lending-program-header {
    color: #43454d;
    font-family: Poppins;
    font-size: 40px;
    font-weight: 700;
    margin-bottom: 15px;

    @media all and (max-width: $grid-breakpoint-lg) {
      font-size: 24px;
    }
  }

  .patient-lending-program-header2 {
    color: #43454d;
    font-family: Poppins;
    font-size: 28px;
    font-weight: 400;
    margin-top: 5px;
    margin-bottom: 30px;

    @media all and (max-width: $grid-breakpoint-md) {
      font-size: 20px;
    }
  }

  .patient-lending-program-main {
    color: #43454d;
    font-family: inherit;
    font-size: 20px;
    font-weight: 400;
    margin-top: 5px;
    margin-bottom: 15px;

    @media all and (max-width: $grid-breakpoint-lg) {
      margin-bottom: 25px;
    }

    @media all and (max-width: $grid-breakpoint-md) {
      font-size: 16px;
    }
  }

  .rowmargin {
    margin-top: 15px;
    margin-bottom: 15px;
  }
}
</style>
